import { createAction, props } from '@ngrx/store';

const SET_INGESTION_ANALYSIS = '[Ingestion Analysis] Set Ingestion Analysis';
const CLEAR_INGESTION_ANALYSIS = '[Ingestion Analysis] Clear Ingestion Analysis';
const RETRY_FAILED_INGESTIONS = '[Ingestion Analysis] Retry Failed Ingestions';
const RETRY_FAILED_INGESTIONS_SUCCESS = '[Ingestion Analysis] Retry Failed Ingestions Success';
const RETRY_FAILED_INGESTIONS_FAILURE = '[Ingestion Analysis] Retry Failed Ingestions Failure';

const setIngestionAnalysis = createAction(SET_INGESTION_ANALYSIS, props<{ data: any }>());

const clearIngestionAnalysis = createAction(CLEAR_INGESTION_ANALYSIS);

const retryFailedIngestions = createAction(
  RETRY_FAILED_INGESTIONS,
  props<{ apiConstants: any; urlVariables: { generationId: string } }>()
);

const retryFailedIngestionsSuccess = createAction(RETRY_FAILED_INGESTIONS_SUCCESS);

const retryFailedIngestionsFailure = createAction(RETRY_FAILED_INGESTIONS_FAILURE);

export const IngestionAnalysisActions = {
  setIngestionAnalysis,
  clearIngestionAnalysis,
  retryFailedIngestions,
  retryFailedIngestionsSuccess,
  retryFailedIngestionsFailure
};
